/* UnuDerm+ cart drawer — opens on Add to Bag and on the header cart icon */
(function () {
  var root = document.getElementById('unu-cart');
  if (!root || root.__ready) return;
  root.__ready = true;

  var cfg = root.dataset;
  var threshold = parseInt(cfg.threshold, 10) || 0;
  var body = root.querySelector('[data-uc-body]');
  var foot = root.querySelector('[data-uc-foot]');
  var ship = root.querySelector('[data-uc-ship]');
  var countEl = root.querySelector('[data-uc-count]');
  var errorEl = root.querySelector('[data-uc-error]');
  var lastFocus = null;
  var tiers = [];
  try { var tEl = root.querySelector('[data-uc-tiers]'); if (tEl) tiers = JSON.parse(tEl.textContent).map(function (t) {
      if (t.amount != null && t.count == null) { t.count = 0; t.value = t.amount; }
      t.count = t.count || 0; t.value = t.value || 0; return t;
    }).filter(function (t) { return t.count > 0 || t.value > 0; }); } catch (e) { tiers = []; }
  var tierBar = root.querySelector('[data-uc-tiersbar]');
  var syncing = false;

  var ICON_TRASH = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M4 7h16M10 11v6M14 11v6M6 7l1 12a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2l1-12M9 7V4h6v3"/></svg>';

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function money(cents) {
    var format = cfg.moneyFormat || 'Rs. {{amount}}';
    var n = (cents / 100).toFixed(2);
    var noDec = format.indexOf('no_decimals') > -1;
    if (noDec) n = Math.round(cents / 100).toString();
    else n = n.replace(/\.00$/, '');
    n = n.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return format.replace(/\{\{\s*[a-z_]+\s*\}\}/, n);
  }
  function img(url, w) {
    if (!url) return '';
    if (url.indexOf('data:') === 0) return url;
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }

  function isGift(it) { return it.properties && it.properties._unu_gift; }
  function stats(cart) {
    var n = 0, v = 0;
    (cart.items || []).forEach(function (it) { if (!isGift(it)) { n += it.quantity; v += it.original_line_price; } });
    return { n: n, v: v };
  }
  function hit(t, st) { return (t.count > 0 && st.n >= t.count) || (t.value > 0 && st.v >= t.value); }
  function reachedCount(st) { var r = 0; for (var i = 0; i < tiers.length; i++) { if (hit(tiers[i], st)) r = i + 1; else break; } return r; }

  function renderTiers(cart) {
    if (!tierBar || !tiers.length) return;
    var st = stats(cart);
    var n = tiers.length, reached = reachedCount(st);
    var pct;
    if (reached >= n) pct = 100;
    else {
      var t = tiers[reached], prev = reached > 0 ? tiers[reached - 1] : { count: 0, value: 0 };
      var fc = t.count > 0 ? (st.n - prev.count) / Math.max(1, t.count - prev.count) : 0;
      var fv = t.value > 0 ? (st.v - prev.value) / Math.max(1, t.value - prev.value) : 0;
      var f = Math.max(0, Math.min(1, Math.max(fc, fv)));
      pct = ((reached + f) / n) * 100;
    }
    tierBar.querySelector('[data-uc-tierlabels]').innerHTML = tiers.map(function (t, i) {
      return '<span class="' + (i < reached ? 'is-on' : '') + '">' + esc(t.label) + '</span>';
    }).join('');
    tierBar.querySelector('[data-uc-ticks]').innerHTML = tiers.map(function (t, i) {
      return '<b class="' + (i < reached ? 'is-on' : '') + '" style="left:' + (((i + 1) / n) * 100 - (i === n - 1 ? 1 : 0)) + '%"></b>';
    }).join('');
    tierBar.querySelector('i').style.width = Math.min(100, pct) + '%';
    var msg = '';
    if (reached >= n) msg = esc(cfg.tierAll);
    else {
      var next = tiers[reached], parts = [];
      if (next.count > 0) { var c = next.count - st.n; parts.push('<strong>' + c + ' more ' + (c === 1 ? 'product' : 'products') + '</strong>'); }
      if (next.value > 0) parts.push('<strong>' + money(next.value - st.v) + ' more</strong>');
      var tpl = cfg.tierProgressCount || 'Add [need] to unlock [reward]';
      var prog = esc(tpl).replace('[need]', parts.join(' or ')).replace('[reward]', '<strong>' + esc(next.name || next.label) + '</strong>');
      msg = reached > 0 ? esc(cfg.tierCongrats).replace('[reward]', esc(tiers[reached - 1].name || tiers[reached - 1].label)) + '<br>' + prog : prog;
    }
    tierBar.querySelector('[data-uc-tiermsg]').innerHTML = msg;
  }

  /* Add or remove free gift lines so they match the unlocked rewards */
  function syncGifts(cart) {
    if (syncing || !tiers.length) return Promise.resolve(cart);
    var st = stats(cart), reached = reachedCount(st);
    var items = cart.items || [];
    var want = {};
    tiers.forEach(function (t, i) { if (t.gift && i < reached) want[t.gift] = true; });
    var have = {};
    var toRemove = [];
    items.forEach(function (it) {
      if (!isGift(it)) return;
      if (want[it.variant_id] && !have[it.variant_id]) { have[it.variant_id] = true; if (it.quantity !== 1) toRemove.push({ key: it.key, qty: 1 }); }
      else toRemove.push({ key: it.key, qty: 0 });
    });
    var toAdd = Object.keys(want).filter(function (id) { return !have[id]; }).map(function (id) { return { id: Number(id), quantity: 1, properties: { _unu_gift: '1' } }; });
    if (!toAdd.length && !toRemove.length) return Promise.resolve(cart);
    syncing = true;
    var base = (window.Shopify && Shopify.routes ? Shopify.routes.root : '/');
    var chain = Promise.resolve();
    toRemove.forEach(function (r) {
      chain = chain.then(function () {
        return fetch(base + 'cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: r.key, quantity: r.qty }) });
      });
    });
    if (toAdd.length) {
      chain = chain.then(function () {
        return fetch(base + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: toAdd }) });
      });
    }
    return chain.then(fetchCart).then(function (c) { syncing = false; return c; }, function () { syncing = false; return cart; });
  }

  function update(cart) {
    render(cart);
    return syncGifts(cart).then(function (c) { if (c !== cart) render(c); return c; });
  }

  function render(cart) {
    var items = cart.items || [];
    renderTiers(cart);
    countEl.textContent = cart.item_count ? '(' + cart.item_count + ')' : '';
    updateBubbles(cart.item_count);

    if (ship) {
      if (threshold > 0) {
        var left = threshold - cart.total_price;
        var pct = Math.min(100, Math.round((cart.total_price / threshold) * 100));
        ship.hidden = false;
        ship.querySelector('[data-uc-ship-text]').innerHTML = left > 0
          ? esc(cfg.shipAway).replace('[amount]', '<strong>' + money(left) + '</strong>')
          : esc(cfg.shipDone);
        ship.querySelector('i').style.width = pct + '%';
      } else {
        ship.hidden = true;
      }
    }

    if (!items.length) {
      body.innerHTML = '<div class="ucart__empty"><p>' + esc(cfg.emptyText) + '</p><a class="ucart__btn ucart__btn--primary" href="' + esc(cfg.shopUrl) + '">' + esc(cfg.emptyButton) + '</a></div>';
      foot.hidden = true;
      recToken++;
      return;
    }
    foot.hidden = false;

    body.innerHTML = items.map(function (it, i) {
      var variant = (it.variant_title && it.variant_title !== 'Default Title') ? '<div class="ucart__variant">' + esc(it.variant_title) + '</div>' : '';
      var plan = it.selling_plan_allocation ? '<div class="ucart__variant">' + esc(it.selling_plan_allocation.selling_plan.name) + '</div>' : '';
      var strike = it.original_line_price > it.final_line_price ? '<s>' + money(it.original_line_price) + '</s>' : '';
      var title = it.product_title || it.title;
      if (isGift(it)) {
        return '<div class="ucart__item ucart__item--gift" data-line="' + (i + 1) + '">' +
          '<a class="ucart__img" href="' + esc(it.url) + '" tabindex="-1" aria-hidden="true">' + (it.image ? '<img src="' + esc(img(it.image, 200)) + '" alt="" loading="lazy">' : '') + '</a>' +
          '<div class="ucart__info"><a class="ucart__name" href="' + esc(it.url) + '">' + esc(title) + '</a>' + variant + '<span class="ucart__gift">' + esc(cfg.giftLabel || 'Free gift') + '</span></div>' +
          '<div class="ucart__side"><span></span><div class="ucart__price">' + money(it.final_line_price) + strike + '</div></div></div>';
      }
      return '<div class="ucart__item" data-line="' + (i + 1) + '">' +
        '<a class="ucart__img" href="' + esc(it.url) + '" tabindex="-1" aria-hidden="true">' + (it.image ? '<img src="' + esc(img(it.image, 200)) + '" alt="" loading="lazy">' : '') + '</a>' +
        '<div class="ucart__info"><a class="ucart__name" href="' + esc(it.url) + '">' + esc(title) + '</a>' + variant + plan +
          '<div class="ucart__qty"><button type="button" data-qty="' + (it.quantity - 1) + '" aria-label="Decrease quantity of ' + esc(title) + '">&minus;</button>' +
          '<span aria-live="polite">' + it.quantity + '</span>' +
          '<button type="button" data-qty="' + (it.quantity + 1) + '" aria-label="Increase quantity of ' + esc(title) + '">+</button></div></div>' +
        '<div class="ucart__side"><button type="button" class="ucart__remove" data-qty="0" aria-label="Remove ' + esc(title) + '">' + ICON_TRASH + '</button>' +
          '<div class="ucart__price">' + money(it.final_line_price) + strike + '</div></div>' +
        '</div>';
    }).join('');
    renderRecs(cart);

    /* Discounts: show exactly what Shopify applies (line + order level), so cart = checkout.
       The reward % estimate is used only when "Show estimated discount" is turned on. */
    var discEl = root.querySelector('[data-uc-discounts]');
    var rows = [];
    var finalTotal = cart.total_price;
    var byTitle = {};
    items.forEach(function (it) {
      (it.line_level_discount_allocations || []).forEach(function (a) {
        var t = (a.discount_application && a.discount_application.title) || 'Discount';
        byTitle[t] = (byTitle[t] || 0) + a.amount;
      });
    });
    (cart.cart_level_discount_applications || []).forEach(function (d) {
      if (d.total_allocated_amount > 0) byTitle[d.title] = (byTitle[d.title] || 0) + d.total_allocated_amount;
    });
    Object.keys(byTitle).forEach(function (t) { if (byTitle[t] > 0) rows.push([t, byTitle[t]]); });
    var itemsTotal = cart.original_total_price;
    if (!rows.length && cfg.estimate === 'true') {
      var reachedPct = 0, rc = reachedCount(stats(cart));
      tiers.forEach(function (t, i) { if (i < rc && t.percent > reachedPct) reachedPct = t.percent; });
      if (reachedPct > 0) {
        var paid = items.reduce(function (sum, it) { return isGift(it) ? sum : sum + it.final_line_price; }, 0);
        var off = Math.round(paid * reachedPct / 10000) * 100;
        rows.push([(cfg.discountLabel || 'Extra [percent]% off').replace('[percent]', reachedPct), off]);
        finalTotal = cart.total_price - off;
        itemsTotal = cart.total_price;
      }
    }
    if (discEl) {
      discEl.hidden = !rows.length;
      discEl.innerHTML = rows.length ? '<div class="ucart__drow"><span>' + esc(cfg.itemsLabel || 'Items total') + '</span><span>' + money(itemsTotal) + '</span></div>' +
        rows.map(function (r) { return '<div class="ucart__drow ucart__drow--off"><span>' + esc(r[0]) + '</span><span>&minus;' + money(r[1]) + '</span></div>'; }).join('') : '';
    }

    var totalStrike = cart.original_total_price > finalTotal ? '<s>' + money(cart.original_total_price) + '</s>' : '';
    root.querySelector('[data-uc-subtotal]').innerHTML = money(finalTotal) + totalStrike;
    root.querySelector('[data-uc-items]').textContent = cart.item_count;
    var saved = root.querySelector('[data-uc-saved]');
    var diff = cart.original_total_price - finalTotal;
    saved.hidden = !(diff > 0);
    if (diff > 0) saved.textContent = cfg.savedText.replace('[amount]', money(diff));
  }

  /* Related products ("Complete your routine") */
  var recCache = {};
  var recToken = 0;
  var base = function () { return (window.Shopify && Shopify.routes ? Shopify.routes.root : '/'); };
  function absImg(u) { if (!u) return ''; if (u.indexOf('//') === 0) return 'https:' + u; return u; }
  function shortTitle(t) { return String(t || '').split(' — ')[0].split(' - ')[0]; }
  function normRec(p) {
    var v = (p.variants || []).filter(function (x) { return x.available !== false; })[0] || (p.variants || [])[0];
    if (!v) return null;
    var cents = function (x) { return x == null ? 0 : (typeof x === 'string' ? Math.round(parseFloat(x) * 100) : x); };
    var image = p.featured_image || (p.images && p.images[0] && (p.images[0].src || p.images[0])) || (v.featured_image && v.featured_image.src) || '';
    if (image && typeof image === 'object') image = image.src || '';
    return { id: p.id, handle: p.handle, title: shortTitle(p.title), url: p.url || ('/products/' + p.handle), image: absImg(image),
      variant: v.id, price: cents(v.price), compare: cents(v.compare_at_price), available: p.available !== false && v.available !== false };
  }
  function getJSON(url) { return fetch(url, { headers: { Accept: 'application/json' } }).then(function (r) { return r.ok ? r.json() : {}; }).catch(function (e) { if (window.console) console.warn('[UnuCart] recs fetch failed', url, e); return {}; }); }
  function loadRecs(productId) {
    if (recCache[productId]) return Promise.resolve(recCache[productId]);
    var u = base() + 'recommendations/products.json?product_id=' + productId + '&limit=8';
    return Promise.all([getJSON(u + '&intent=complementary'), getJSON(u + '&intent=related')]).then(function (res) {
      var list = (res[0].products || []).concat(res[1].products || []);
      if (list.length >= 6) return list;
      return getJSON(base() + 'collections/all/products.json?limit=12').then(function (d3) { return list.concat(d3.products || []); });
    }).then(function (list) { recCache[productId] = list; return list; });
  }
  function renderRecs(cart) {
    var heading = (cfg.recsHeading == null) ? 'Complete your routine' : cfg.recsHeading;
    var old = body.querySelector('[data-uc-recs]');
    var items = (cart.items || []).filter(function (it) { return !isGift(it); });
    if (!heading || !items.length) { if (old) old.remove(); return; }
    var inCart = {};
    (cart.items || []).forEach(function (it) { inCart[it.product_id] = true; });
    var token = ++recToken;
    loadRecs(items[0].product_id).then(function (list) {
      if (token !== recToken) return;
      var seen = {};
      var recs = list.map(normRec).filter(function (r) {
        if (!r || !r.available || inCart[r.id] || seen[r.id]) return false;
        seen[r.id] = true; return true;
      }).slice(0, 4);
      var wrap = body.querySelector('[data-uc-recs]');
      if (!recs.length) { if (wrap) wrap.remove(); return; }
      if (!wrap) { wrap = document.createElement('div'); wrap.className = 'ucart__recs'; wrap.setAttribute('data-uc-recs', ''); body.appendChild(wrap); }
      wrap.innerHTML = '<p class="ucart__recs-title">' + esc(heading) + '</p><div class="ucart__recs-track">' + recs.map(function (r) {
        var strike = r.compare > r.price ? '<s>' + money(r.compare) + '</s>' : '';
        return '<div class="ucart__rec">' +
          '<a class="ucart__rec-img" href="' + esc(r.url) + '" tabindex="-1" aria-hidden="true">' + (r.image ? '<img src="' + esc(img(r.image, 240)) + '" alt="" loading="lazy">' : '') + '</a>' +
          '<a class="ucart__rec-name" href="' + esc(r.url) + '">' + esc(r.title) + '</a>' +
          '<span class="ucart__rec-price">' + money(r.price) + strike + '</span>' +
          '<button type="button" class="ucart__rec-add" data-uc-rec="' + r.variant + '" aria-label="Add ' + esc(r.title) + ' to cart">+ Add</button>' +
        '</div>';
      }).join('') + '</div>';
    });
  }
  function addRec(btn) {
    btn.disabled = true; btn.textContent = 'Adding...';
    fetch(base() + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: Number(btn.getAttribute('data-uc-rec')), quantity: 1 }) })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
      .then(function (res) {
        if (!res.ok) { showError(res.d.description || res.d.message); btn.disabled = false; btn.textContent = '+ Add'; return; }
        return fetchCart().then(update);
      })
      .catch(function () { showError(cfg.errorText); btn.disabled = false; btn.textContent = '+ Add'; });
  }

  function updateBubbles(count) {
    document.querySelectorAll('.cart-count-bubble span[aria-hidden="true"], [data-cart-count]').forEach(function (el) {
      el.textContent = count;
    });
    document.querySelectorAll('.cart-count-bubble').forEach(function (el) { el.hidden = !count; });
  }

  function fetchCart() {
    return fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); });
  }

  function open() {
    lastFocus = document.activeElement;
    root.hidden = false;
    document.body.classList.add('ucart-lock');
    requestAnimationFrame(function () { root.classList.add('is-open'); });
    setTimeout(function () { root.querySelector('.ucart__close').focus(); }, 50);
  }
  function close() {
    root.classList.remove('is-open');
    document.body.classList.remove('ucart-lock');
    setTimeout(function () { root.hidden = true; }, 300);
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  function showError(msg) { errorEl.textContent = msg || ''; }

  function change(line, qty, itemEl) {
    if (itemEl) itemEl.classList.add('is-busy');
    showError('');
    fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: line, quantity: qty })
    }).then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
      .then(function (res) {
        if (!res.ok) { showError(res.d.description || res.d.message); return fetchCart().then(update); }
        update(res.d);
      })
      .catch(function () { showError(cfg.errorText); if (itemEl) itemEl.classList.remove('is-busy'); });
  }

  /* Drawer controls */
  root.addEventListener('click', function (e) {
    if (e.target.closest('[data-uc-close]')) { e.preventDefault(); close(); return; }
    var rb = e.target.closest('[data-uc-rec]');
    if (rb) { if (!rb.disabled) addRec(rb); return; }
    var q = e.target.closest('[data-qty]');
    if (q) {
      var item = q.closest('.ucart__item');
      change(parseInt(item.dataset.line, 10), Math.max(0, parseInt(q.dataset.qty, 10)), item);
    }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && root.classList.contains('is-open')) close();
    if (e.key === 'Tab' && root.classList.contains('is-open')) {
      var f = root.querySelectorAll('.ucart__panel a[href], .ucart__panel button:not([disabled])');
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });

  /* Header cart icon opens the drawer instead of the cart page */
  document.addEventListener('click', function (e) {
    var a = e.target.closest('a[href]');
    if (!a || root.contains(a)) return;
    var path = a.pathname.replace(/\/$/, '');
    if (/\/cart$/.test(path) && !e.metaKey && !e.ctrlKey && !e.shiftKey) {
      e.preventDefault();
      fetchCart().then(update).then(open);
    }
  }, true);

  /* Every Add to cart / Add to Bag form on the site adds via AJAX and opens the drawer */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.action || form.action.indexOf('/cart/add') === -1) return;
    if (e.submitter && e.submitter.name === 'checkout') return;
    e.preventDefault();
    e.stopPropagation();
    var btn = form.querySelector('[type="submit"]');
    if (btn) { btn.setAttribute('aria-busy', 'true'); btn.disabled = true; }
    var data = new FormData(form);
    if (data.get('selling_plan') === '') data.delete('selling_plan');
    fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', {
      method: 'POST', headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: data
    }).then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
      .then(function (res) {
        return fetchCart().then(update).then(function () {
          showError(res.ok ? '' : (res.d.description || res.d.message));
          open();
        });
      })
      .catch(function () { form.submit(); })
      .finally(function () { if (btn) { btn.removeAttribute('aria-busy'); btn.disabled = false; } });
  }, true);

  window.UnuCart = { open: function () { fetchCart().then(update).then(open); }, refresh: function () { return fetchCart().then(update); } };
})();